import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { ContactService } from "../../services/ContactService";

export const useContacts = (orgId) => {
  return useQuery({
    queryKey: ["contacts", orgId],
    queryFn: () => ContactService.fetchContacts(orgId),
    enabled: !!orgId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export const useContact = (contactId) => {
  return useQuery({
    queryKey: ["contact", contactId],
    queryFn: () => ContactService.fetchContact(contactId),
    enabled: !!contactId,
    staleTime: 1000 * 60 * 5,
  });
};

export const useCreateContact = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ContactService.createContact,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["contacts", variables.organisation_id],
      });
    },
  });
};

export const useUpdateContact = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ contactId, data }) =>
      ContactService.updateContact(contactId, data),
    onSuccess: (_, { contactId, orgId }) => {
      queryClient.invalidateQueries({ queryKey: ["contact", contactId] });
      queryClient.invalidateQueries({ queryKey: ["contacts", orgId] });
    },
  });
};

export const useDeleteContact = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ contactId }) => ContactService.deleteContact(contactId),
    onSuccess: (_, { contactId, orgId }) => {
      queryClient.invalidateQueries({ queryKey: ["contacts", orgId] });
      queryClient.removeQueries({ queryKey: ["contact", contactId] });
    },
  });
};
